import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "HaPerCountry": {
        meta: {
            i18nDescrKey: "ha-per-country",
            filters: ["campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/HaPerCountry.vue")
    },

    "TotalScorePerVarietyYear": {
        meta: {
            i18nDescrKey: "total-score-per-variety-year",
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/TotalScorePerVarietyYear.vue")
    }

}

export default globals;
